var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.75 3.25V7.25H12.25V8.75H7.25V3.25H8.75Z","fill":"#181818","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8ZM8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 11.4518 4.54822 14.25 8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75Z","fill":"#181818","key":1})]);
}

Clock.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
